import cn from "classnames";
import React, { ReactNode } from "react";
import { useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface Props {
  title: string;
  children?: ReactNode;
  selector?: ReactNode;
  legend?: ReactNode;
  badge?: string;
  variant?: "bar" | "donut";
  isEmpty?: boolean;
  className?: string;
  id?: string;
}

export const CrmChartCard = ({
  title,
  children,
  selector,
  legend,
  badge,
  variant = "bar",
  isEmpty = false,
  className,
  id,
}: Props) => {
  const intl = useIntl();

  return (
    <article id={id} className={cn("crm-chart-card", className)}>
      <header className="crm-chart-card__header">
        <div className="crm-chart-card__title-wrap">
          <h3 className="crm-chart-card__title">{title}</h3>
          {badge && <span className="crm-chart-card__badge">{badge}</span>}
        </div>
        {selector && (
          <div className="crm-chart-card__selector">{selector}</div>
        )}
      </header>

      <div
        className={cn("crm-chart-card__body", {
          "crm-chart-card__body--bar": variant === "bar",
          "crm-chart-card__body--donut": variant === "donut",
        })}
      >
        {isEmpty ? (
          <div className="crm-chart-card__empty">
            <div className="crm-chart-card__empty-icon">
              <FontAwesomeIcon icon={["fas", "chart-pie"]} />
            </div>
            <p>{intl.formatMessage({ id: "app.analiyticsFace.noDate" })}</p>
          </div>
        ) : variant === "donut" ? (
          <>
            <div className="crm-chart-card__chart-area">{children}</div>
            {legend && (
              <div className="crm-chart-card__legend-area">{legend}</div>
            )}
          </>
        ) : (
          <div className="crm-chart-card__bar-area">{children}</div>
        )}
      </div>
    </article>
  );
};
